var _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreHeaderBshopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 24,
    viewBox: "0 0 68 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5557 5.22662C31.5557 7.07163 31.5557 8.11991 31.5557 9.96492L31.5557 15.9409M31.5557 19.9298V15.9409M31.5557 15.9409C31.5557 13.7642 31.5294 10.4412 35.3224 10.4412C39.3133 10.4412 39.0291 13.7651 39.0291 15.8223C39.0291 17.8794 39.0291 18.0531 39.0291 19.9298",
    stroke: "white",
    strokeWidth: 2.3726
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.3268,
    cy: 14.2356,
    r: 4.50793,
    stroke: "white",
    strokeWidth: 2.3726
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0098 14.4728L58.0098 23.2514H55.6372L55.6372 14.4728L58.0098 14.4728Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6064,
    cy: 18.6546,
    r: 1.48287,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4712 8.67822C22.5231 8.67822 21.5235 8.8368 20.6906 9.2652C19.8246 9.71058 19.0902 10.4851 18.9327 11.6385L18.9321 11.6425C18.9059 11.8345 18.7699 12.8288 19.391 13.7965C20.0697 14.8541 21.3866 15.5027 23.4713 15.5027V15.5027C25.085 15.5027 25.4676 15.9821 25.5547 16.1178C25.695 16.3364 25.6699 16.5934 25.659 16.6734C25.6302 16.8843 25.5182 17.077 25.1667 17.2578C24.7822 17.4555 24.1933 17.582 23.4712 17.582C22.1887 17.582 21.3591 17.0703 20.1772 16.2993L18.8809 18.2865L18.9223 18.3135C20.0828 19.0708 21.4374 19.9546 23.4712 19.9546C24.4194 19.9546 25.4189 19.7961 26.2519 19.3677C27.1178 18.9223 27.8523 18.1477 28.0098 16.9944L28.0103 16.9903C28.0366 16.7984 28.1725 15.8041 27.5515 14.8363C26.8727 13.7787 25.5559 13.1301 23.4712 13.1301V13.1301C21.8575 13.1301 21.4749 12.6508 21.3877 12.515C21.2475 12.2965 21.2726 12.0395 21.2835 11.9594C21.3123 11.7485 21.4243 11.5559 21.7757 11.3751C22.1602 11.1773 22.7492 11.0508 23.4712 11.0508C24.7537 11.0508 25.5834 11.5625 26.7653 12.3335L28.0616 10.3464L28.0202 10.3193C26.8597 9.5621 25.5051 8.67822 23.4712 8.67822Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.9419,
    cy: 14.3551,
    r: 4.62746,
    stroke: "white",
    strokeWidth: 2.3726
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.2356V14.8873H0.0368954C0.360278 17.7252 2.7698 19.9298 5.69423 19.9298C8.83907 19.9298 11.3885 17.3804 11.3885 14.2356C11.3885 11.0907 8.83907 8.54133 5.69423 8.54133C4.45461 8.54133 3.30751 8.93745 2.3726 9.61V5.69421L0 5.69421V14.2356ZM2.3726 14.2338C2.3726 14.2344 2.3726 14.235 2.3726 14.2356C2.3726 14.2362 2.3726 14.2367 2.3726 14.2373C2.37355 16.071 3.86033 17.5572 5.69423 17.5572C7.52872 17.5572 9.01587 16.0701 9.01587 14.2356C9.01587 12.4011 7.52872 10.9139 5.69423 10.9139C3.86033 10.9139 2.37355 12.4001 2.3726 14.2338Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3354 5.69404L47.8221 1.42358L55.5205 5.69426",
    stroke: "#206BFF",
    strokeWidth: 2.3726,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreHeaderBshopIcon);
export default __webpack_public_path__ + "static/media/store_header_bshop_icon.99cd9df197f0245429a0450ae824ac28.svg";
export { ForwardRef as ReactComponent };